// @ts-nocheck
import CustomerZoneAppointmentDetail from '@/PageComponents/CustomerZone/CustomerZoneAppointment/CustomerZoneAppointmentDetail';
import { createFileRoute } from '@tanstack/react-router';

export default CustomerZoneAppointmentDetail;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/viewappointment')({ component: CustomerZoneAppointmentDetail });
